import { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { succsesDataDeleteAlert } from "../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../redux/services/crmAPI";
import { useSelector } from "react-redux";

const Services = () => {
    const { id } = useParams();

    const permissions = useSelector((state) => state.status.permissions);

    const [deleteService, { isLoading, isError }] = useSendFormMutation();
    const { data: servicesList, refetch: refetchServices } = useGetPageQuery("services?per_page=300&active=" + id);

    const [checkedServicesList, seCheckedServicesList] = useState([]);

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            seCheckedServicesList([...checkedServicesList, e.target.value]);
        } else if (!e.target.checked) {
            seCheckedServicesList([...checkedServicesList.filter((id) => id !== e.target.value)]);
        }
    };

    const deleteServiceHandler = async () => {
        for (const service of checkedServicesList) {
            await deleteService({ body: {}, url: "services/" + service, method: "DELETE" });
        }

        if (!isError) {
            succsesDataDeleteAlert();
        }

        await refetchServices();
    };

    const checkAllHandler = () => {
        seCheckedServicesList(servicesList.data.map((user) => user.id.toString()));
    };

    useEffect(() => {
        const refetch = async () => {
            refetchServices();
        };
        refetch();
    }, [servicesList]);

    return (
        <>
            {servicesList && (
                <div className="content">
                    <div className="col-12">
                        <div className="page-header d-flex justify-content-between align-items-center mb-3">
                            <div className="header">
                                <h1>Послуги</h1>
                            </div>
                            <div className="page-header__button">
                                <div className="float-right">
                                    <Link to={"/service"} className="add btn btn-primary">
                                        Додати послугу
                                    </Link>
                                </div>
                            </div>
                        </div>
                        <ul className="nav-bordered nav nav-tabs mb-3">
                            <li className="nav-item">
                                <Link to={"/services/1"} className={+id === 1 ? "nav-link active" : "nav-link"}>
                                    <span className=" d-lg-block">Активні</span>
                                </Link>
                            </li>
                            <li className="nav-item">
                                <Link to={"/services/0"} className={+id === 0 ? "nav-link active" : "nav-link"}>
                                    <span className=" d-lg-block">Деактивовані</span>
                                </Link>
                            </li>
                        </ul>
                        <div id="list_form">
                            <a className="check_all" onClick={checkAllHandler}>
                                Виділити все
                            </a>
                            <table className="table table-striped ui-sortable">
                                <thead>
                                    <tr>
                                        <th data-field="move"></th>
                                        <th data-field="check"></th>

                                        <th data-field="id">ID</th>
                                        <th data-field="user_name">Назва</th>
                                        <th data-field="user_phone">Ціна</th>
                                        <th data-field="user_phone" className="no-mobile">
                                            Статус
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {servicesList.data.map((service) => {
                                        return (
                                            <tr key={service.id}>
                                                <td className="td_move fit">
                                                    <input type="hidden" name="positions[1]" value="1" />
                                                    <i className="bi bi-list"></i>
                                                </td>
                                                <td className="check_area text-right fit">
                                                    <div className="custom-control custom-checkbox">
                                                        <input
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={checkedServicesList.includes(
                                                                service.id.toString()
                                                            )}
                                                            value={service.id}
                                                            onChange={(e) => listCheckHandler(e)}
                                                        />
                                                        <label className="custom-control-label">&nbsp;</label>
                                                    </div>
                                                </td>
                                                <td className="fit">#{service.id}</td>
                                                <td>
                                                    <Link to={"/service/" + service.id}>{service.title}</Link>
                                                </td>
                                                <td className="fit">{service.price}</td>
                                                <td className="fit no-mobile">Активна</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                            {permissions.includes("service_edit") || permissions.includes("all") ? (
                                <div className="d-flex">
                                    <select name="action" className="form-select" style={{ width: "auto" }}>
                                        <option value="delete">Видалити</option>{" "}
                                    </select>
                                    <button className="btn btn-info mx-3" onClick={deleteServiceHandler}>
                                        {isLoading ? "Завантаження" : "Виконати"}
                                    </button>
                                </div>
                            ) : null}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Services;
